// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#gradient-primary-1{--color-stop-1:#4c70fe;--color-stop-2:#df44df}#gradient-secondary-1{--color-stop-3:#00e8b9;--color-stop-4:#0061bf}#gradient-primary-1--circular{--color-stop-1:#3643ef;--color-stop-2:#9400d1}.gradient-primary-1--icon .v-icon__svg{fill:url(#gradient-primary-1)}.gradient-secondary-1--icon .v-icon__svg{fill:url(#gradient-secondary-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
